"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumeric = exports.getNumberPrecision = exports.getDecimalPlacesNum = exports.getNumberRegex = exports.getGroupSeparator = exports.getDecimalSeparator = void 0;
const types_1 = require("@smartsuite/types");
function getDecimalSeparator(locale) {
    const decimalNumber = 1.1;
    return locale ? decimalNumber.toLocaleString(locale).substring(1, 2) : ".|,";
}
exports.getDecimalSeparator = getDecimalSeparator;
function getGroupSeparator(locale) {
    const numberWithGroup = 10000;
    return locale ? numberWithGroup.toLocaleString(locale).substring(2, 3) : " ";
}
exports.getGroupSeparator = getGroupSeparator;
/**
 *
 * @param precision Number of allowed digits after . for decimal
 * @param allowNegative Specifies if negative numbers are allowed
 * @param partial Used for inline edit when we don't need to validate fully
 * @param strict Used for copy/paste when we need to match the number inside of string
 * @param locale User's locale value, e.g. "en-US"
 * @param maxDigits Max number of digits to match
 * @param allowZero Specifies if zero number is allowed
 */
function getNumberRegex(precision = 0, allowNegative = false, partial = false, strict = true, locale = null, maxDigits = types_1.maxWholeDigits, allowZero = true) {
    // TODO: Split on two more simple functions
    // Restrict '-' if negative not allowed
    // Restrict decimal pointer if no precision
    // Restrict not numbers
    const negativeRegex = allowNegative ? "-?" : "";
    const wholeNumberRegex = partial
        ? `\\d{0,${maxDigits}}`
        : `\\d{1,${maxDigits}}`;
    const decimalSeparator = getDecimalSeparator(locale);
    const fractionNumberRegex = precision.toString() !== "0"
        ? `([${decimalSeparator}]\\d{0,${precision}})?`
        : "";
    const regex = `${negativeRegex}${wholeNumberRegex}${fractionNumberRegex}`;
    let result = strict ? `^${regex}$` : regex;
    if (allowNegative) {
        if (!partial) {
            // Restrict negative zeros
            result = "(?!-[,.0]*$)" + result;
        }
        else {
            // Allow single '-' if negative, for partial enter
            result += "|^-?$";
        }
    }
    if (!allowZero) {
        result = "(?!^0$)" + result;
    }
    return new RegExp(result);
}
exports.getNumberRegex = getNumberRegex;
/**
 * Get a number of decimal places.
 *
 * @example
 * getDecimalPlacesNum(10.00)  // equals 2
 * getDecimalPlacesNum('10.00')  // equals 2
 * getDecimalPlacesNum('10.')  // equals 0
 * getDecimalPlacesNum('10')  // equals 0
 *
 * @param value   numeric value with . as decimal separator
 */
function getDecimalPlacesNum(value) {
    var _a;
    if (value === null) {
        return 0;
    }
    return ((_a = String(value).split(".")[1]) !== null && _a !== void 0 ? _a : "").length;
}
exports.getDecimalPlacesNum = getDecimalPlacesNum;
const getNumberPrecision = (value) => {
    var _a, _b;
    if (value === null) {
        return 0;
    }
    const splittedValue = String(value).split(".");
    return (_b = (_a = splittedValue[1]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
};
exports.getNumberPrecision = getNumberPrecision;
// eslint-disable-next-line
function isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat
    return !Array.isArray(val) && val - parseFloat(val) + 1 >= 0;
}
exports.isNumeric = isNumeric;
